// extracted by mini-css-extract-plugin
export default {"leadLockedRoot":"leadLocked_leadLockedRoot__7qUJ1"};